import * as THREE from 'three'
import { isCachedMaterial } from '../materials/materialFactory'

// Dispose per-clone GPU resources. Geometry is always cloned per instance
// by `cloneWithIndependentMaterials`, so safe to dispose. Materials are
// disposed only when not cache-owned — cached materials are shared across
// many meshes and live for the app lifetime. Cached materials' textures
// are also shared and must never be disposed here.
export const disposeObject = (obj: THREE.Object3D): void => {
  obj.traverse((child) => {
    if (!(child instanceof THREE.Mesh)) return
    const mesh = child

    if (mesh.geometry) {
      mesh.geometry.dispose()
    }

    if (mesh.material) {
      const materials = Array.isArray(mesh.material)
        ? mesh.material
        : [mesh.material]
      materials.forEach((mat) => {
        if (mat instanceof THREE.Material && !isCachedMaterial(mat)) {
          mat.dispose()
        }
      })
    }
  })

  if (obj.parent) {
    obj.parent.remove(obj)
  }
}
